import { createContext, useState } from 'react';

export const ClaimContext = createContext();

export const transitionTimeout = 400;

const ClaimContextProvider = props => {
  const [currentStep, setCurrentStep] = useState(0);
  const [steps, setSteps] = useState([]);
  const [alreadyOpen, setAlreadyOpen] = useState(false);
  const [finish, setFinish] = useState(false);
  const [openBackDrop, setOpenBackDrop] = useState(false);
  const [selectedClaimId, setSelectedClaimId] = useState(null);

  const stepBack = () => {
    steps[currentStep].transition.exit();
    setTimeout(() => {
      setCurrentStep(currentStep - 1);
    }, transitionTimeout);
  };

  const stepForward = () => {
    steps[currentStep].transition.exit();
    setTimeout(() => {
      setCurrentStep(currentStep + 1);
    }, transitionTimeout);
  };

  const setStepElements = (stepIndex, step) => {
    let updatedSteps = steps.slice(0, stepIndex);
    updatedSteps[stepIndex] = step;
    setSteps(updatedSteps);
  };

  const clearSteps = () => {
    setCurrentStep(0);
    setSteps([]);
    setAlreadyOpen(false);
    setFinish(false);
  };

  const finishAndExit = () => {
    setFinish(true);
    setOpenBackDrop(false);
  };

  return (
    <ClaimContext.Provider
      value={{
        currentStep,
        setCurrentStep,
        steps,
        setStepElements,
        stepBack,
        stepForward,
        alreadyOpen,
        setAlreadyOpen,
        clearSteps,
        finish,
        setFinish,
        finishAndExit,
        openBackDrop,
        setOpenBackDrop,
        selectedClaimId,
        setSelectedClaimId,
      }}>
      {props.children}
    </ClaimContext.Provider>
  );
};

export default ClaimContextProvider;
